
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainShowersNight as ObiLightningLightRainShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-showers-night.js';
 
 
 

 
 export const ObiLightningLightRainShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-showers-night',
   elementClass: ObiLightningLightRainShowersNightElement,
   events: {
     
   }
  });
 
 